import React, { Fragment } from "react";
import TimeTrackingStatisticsPage from "./TimeTrackingStatisticsPage";

const PublicTimeTrackingPage: React.FC = () => {
  return (
    <Fragment>
      <div style={{
        padding: '20px',
        background: '#f5f5f5',
        minHeight: '100vh'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          background: 'white',
          borderRadius: '8px',
          padding: '20px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
        }}>
          <div style={{
            textAlign: 'center',
            marginBottom: '30px',
            paddingBottom: '20px',
            borderBottom: '2px solid #f0f0f0'
          }}>
            <h1 style={{
              color: '#1890ff',
              fontSize: '28px',
              fontWeight: 'bold',
              margin: '0 0 10px 0'
            }}>
              ⏱ Thống kê Time Tracking
            </h1>
            <p style={{
              color: '#666',
              fontSize: '16px',
              margin: 0
            }}>
              Giờ làm việc và thống kê trễ daily (bắt đầu sau 8h05, trước 12h)
            </p>
          </div>

          <TimeTrackingStatisticsPage
            endpoint="/api/public/time-tracking/statistics"
            persistMemberLayout
          />
        </div>
      </div>
    </Fragment>
  );
};

export default PublicTimeTrackingPage;
